export const BaiduHTMLSellersMapId = 'map-sellers'
